import { combineReducers } from '@reduxjs/toolkit';
import { loginReducer } from "./LoginReducer";
import { errorReducer } from "./ErrorReducer"; 
import loadingReducer from './loadingSlice.jsx';
import filtersStoresReducer from './filtersStoresSlice.jsx'; 
import paginationStoresReducer from './paginationStoresSlice';

const rootReducer = combineReducers({
  loginUser: loginReducer,
  loadError: errorReducer, 
  loading: loadingReducer,
  filtersStores: filtersStoresReducer,
  paginationStores: paginationStoresReducer
  
});

export default rootReducer;
